export default (wildWalue = null) => ({
  filterData: [],
  indicator: null,
  isMobile: null,
  range: null,
  rangeValue: null,
  ticks: [0, 25, 50, 75, 100],
  wildValue: wildWalue,
  outfitInputRange: {
    [":style"]() {
      return { width: `${this.wildValue || "0"}%` };
    },
  },

  init() {
    this.range = document.getElementById("outfitInput");
    this.indicator = document.getElementById("outfitIndicator");
    this.range.addEventListener("input", this.setIndicatorValue.bind(this));
    this.setIsMobile();
    this.setIndicatorValue();
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
  },

  getClosest(arr, val) {
    return arr.reduce(function (prev, curr) {
      return Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev;
    });
  },

  setIndicatorValue(event = null) {
    const eventTargetValue = event?.target?.value;
    const value = eventTargetValue || this.wildValue;
    this.rangeValue = value;

    if (value === null) {
      this.range.style.background = null;
      this.indicator.style.left = "50%";
      this.indicator.innerHTML = `<span>Choose Style</span>`;
      this.range.value = 50;
      this.range.classList.add("init");
    } else {
      this.range.classList.remove("init");
      const indicatorValue = eventTargetValue
        ? this.getClosest(this.ticks, eventTargetValue)
        : this.wildValue;

      this.range.style.background =
        "linear-gradient(to right, #000 0%, #000 " +
        value +
        "%, #D9D9D9 " +
        value +
        "%, #D9D9D9 100%)";

      const newValue = Number(
          ((value - this.range.min) * 100) / (this.range.max - this.range.min)
        ),
        newPosition = 10 - newValue * 0.2;
      this.indicator.innerHTML = `<span data-first="[" data-last="]">${indicatorValue}%</span>`;
      this.indicator.style.left = `calc(${newValue}% + (${newPosition}px))`;
    }
  },

  setWildValue(value) {
    this.wildValue = this.getClosest(this.ticks, value);
    this.setIndicatorValue();
    this.updateHandler(this.wildValue);
  },

  updateHandler(value) {
    const searchParams = `filter.p.m.outfit.mild_to_wild=${value}`;
    this.renderPage(searchParams);
  },

  resetSlider() {
    this.wildValue = null;
    this.setIndicatorValue();
  },

  removeFacet(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    if (!url) {
      this.resetSlider();
    }
    this.renderPage(url);
  },

  getSections() {
    return [
      {
        section: document.getElementById("outfit-grid").dataset.id,
      },
    ];
  },

  renderPage(searchParams, updateURLHash = true) {
    const sections = this.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      this.filterData.some(filterDataUrl)
        ? this.renderSectionFromCache(filterDataUrl)
        : this.renderSectionFromFetch(url);
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  },

  renderSectionFromCache(filterDataUrl) {
    const html = this.filterData.find(filterDataUrl).html;
    this.renderFilters(html);
    this.renderProductGridContainer(html);
  },

  renderSectionFromFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];
        this.renderFilters(html);
        this.renderProductGridContainer(html);
      });
  },

  renderFilters(html) {
    document.getElementById("OutfitGridFilters").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("OutfitGridFilters").innerHTML;
  },

  renderProductGridContainer(html) {
    document.getElementById("OutfitGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("OutfitGridContainer").innerHTML;
  },

  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  },
});

class FacetRemoveCollectionOutfit extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.setAttribute("x-on:click", "removeFacet");
  }
}

customElements.define(
  "facet-remove-collection-outfit",
  FacetRemoveCollectionOutfit
);
